export default "__VITE_ASSET__CswW5zgH__"